// removed by extract-text-webpack-plugin
module.exports = {"defaultInput":"LZY7fb54","footer":"lRexCFht","content":"u_m0L83R","locales":"_1oPTnatf"};


//////////////////
// WEBPACK FOOTER
// ./src/client/webapp/components/Footer/Footer.styl
// module id = 370
// module chunks = 0